export default function Chip( { txt, backgroundColor } ){
    if (!txt) return null;

    return(
        <div style = { { display : "inline-flex", backgroundColor : backgroundColor, borderRadius : "var(--radius)", padding : "0px 8px", alignItems : "center", justifyContent : "center" } }>
            <p style = { { fontSize : "12px", textAlign : "center" } }>{ txt }</p>
        </div>
    )
}